import React from 'react'

import { Footer } from '@kbbsdk/global-sdk/navigation/web'

export default ({ links = [], isDesktop = true }) => <Footer id={'globalFooter'} navigation={links} enableOneTrust={true} />
